import type { EventCategory } from "@/lib/events";
import bar from "@/assets/event-bar.jpg";
import club from "@/assets/event-club.jpg";
import concert from "@/assets/event-concert.jpg";
import rooftop from "@/assets/event-rooftop.jpg";
import dj from "@/assets/event-dj.jpg";

const GALLERY_POOL = [club, rooftop, concert, bar, dj];

export interface MockReview {
  id: string;
  author: string;
  rating: number;
  text: string;
  date: string;
}

function hash(id: string): number {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return h;
}

export function mockRating(id: string): number {
  const h = hash(id);
  return Math.round((3.9 + (h % 110) / 100) * 10) / 10;
}

export function mockGallery(primary: string, id: string): string[] {
  const h = hash(id);
  const len = GALLERY_POOL.length;
  const i0 = h % len;
  const i1 = (h + 2) % len;
  const i2 = (h + 4) % len;
  // indices are in bounds via modulo
  const extras = [
    GALLERY_POOL[i0]!,
    GALLERY_POOL[i1]!,
    GALLERY_POOL[i2]!,
  ].filter((u) => u !== primary);
  return [primary, ...extras.slice(0, 3)];
}

const MOCK_AUTHORS = ["Maya", "Jonas", "Sofia"] as const;

export function mockReviews(id: string): MockReview[] {
  const h = hash(id);
  const snippets = [
    "Incredible vibe — will definitely come back.",
    "Great music and friendly crowd.",
    "Perfect spot for a night out in the city.",
  ];
  return snippets.map((text, i) => ({
    id: `${id}-r${i}`,
    author: MOCK_AUTHORS[i] ?? "Guest",
    rating: 4 + ((h + i) % 2),
    text,
    date: `${1 + i}d ago`,
  }));
}

export function isOutdoorCategory(category: EventCategory): boolean {
  return category === "Rooftop";
}
